import React from "react";
import { useTranslation } from "react-i18next";
import { RoomCardProps } from "../../types/screensTypes";
import styles from "./MuseumRoomCard.module.css";

const RoomCard: React.FC<RoomCardProps> = ({ data, onClick, onDelete }) => {
    const { pictureUrl, planUrl, internalName, floorNumber } = data;
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const imageSrc = planUrl || pictureUrl;

    return (
        <div className={styles.card} onClick={() => onClick()}>
            {imageSrc ? (
                <img src={imageSrc} alt={internalName} className={styles.image} />
            ) : (
                <div className={`${styles.image} ${styles.imageEmpty}`} />
            )}

            <div className={styles.content}>
                <h3 className={styles.title}>{internalName || t("unnamed")}</h3>
                <div className={styles.row}>
                    <p className={styles.detail}>
                        <strong>
                            {t("floorWithSemicolon")} <span>{floorNumber}</span>
                        </strong>
                    </p>
                    <button
                        type="button"
                        className={styles.deleteBtn}
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation();
                            onDelete();
                        }}
                    >
                        {t("delete")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RoomCard;
